// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"587":"89b9f4a9","695":"ba909fb3","770":"55c32347"}[chunkId] + ".chunk.css";
};